import { ROWS, COLS } from './BoardPack.mjs';

export function compareBoards(before, after) {
    const rows = board => Array.from({ length: ROWS }, (_, y) => (board.layout[y] || '').slice(0, COLS).padEnd(COLS, ' '));
    const left = rows(before), right = rows(after), changes = [];
    const totals = { added: 0, removed: 0, replaced: 0 };
    for (let y = 0; y < ROWS; y++) for (let x = 0; x < COLS; x++) {
        if (left[y][x] === right[y][x]) continue;
        const type = left[y][x] === ' ' ? 'added' : right[y][x] === ' ' ? 'removed' : 'replaced';
        totals[type]++;
        changes.push({ x, y, before: left[y][x], after: right[y][x], type });
    }
    const positions = rows => rows.flatMap((row, y) => [...row].flatMap((char, x) => char === 'p' ? [{ x, y }] : []));
    const oldPlayer = positions(left), newPlayer = positions(right);
    const playerMoved = oldPlayer.length === 1 && newPlayer.length === 1 && JSON.stringify(oldPlayer) !== JSON.stringify(newPlayer);
    const tiles = [['V', 'Generators'], ['*', 'Rock eaters'], ['=', 'Floor cells'], ['H', 'Ladder cells'], ['|', 'Wall cells'], ['-', 'Vanishing floor cells'], ['^', 'Fire cells'], ['$', 'Treasures'], ['&', 'Statues'], ['.', 'Trampolines']];
    const count = (rows, tile) => rows.join('').split(tile).length - 1;
    const tileChanges = tiles.map(([tile, label]) => ({ tile, label, before: count(left, tile), after: count(right, tile) })).filter(item => item.before !== item.after);
    return { left, right, changes, totals, playerMoved, oldPlayer, newPlayer, tileChanges, nameChanged: before.name !== after.name };
}
